export const constants = {
    RESET: "RESET",
    CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
    HIDE_LOADER: "HIDE_LOADER",
    USER_CHECK_LOGIN: "USER_CHECK_LOGIN",
    SET_PERSON_DATA: "SET_PERSON_DATA",
    USER_LOGOUT: "USER_LOGOUT",
    USER_DATA: 'USER_DATA',
    RELATED_PERSONS_DATA:'RELATED_PERSONS_DATA',
    ACTIVE_PERSON_ID:'ACTIVE_PERSON_ID',
    SET_CURRENT_USER_SETTINGS: 'SET_CURRENT_USER_SETTINGS',
    SET_DASHBOARD_LOADED : 'SET_DASHBOARD_LOADED',
    SET_IS_DIRTY:'SET_IS_DIRTY',
    APP: {
        TOGGLE_LOADER: "TOGGLE_LOADER",
        UPDATE_ROUTES: "UPDATE_ROUTES",
        CHANGE_THEME: 'CHANGE_THEME',
        FIRST_RENDER_UPDATE: "FIRST_RENDER_UPDATE",
        STORE_NOTIFICATIONS: "STORE_NOTIFICATIONS",
        CHANGE_ACTIVE_TAB: "CHANGE_ACTIVE_TAB",
        SIDEBAR_ACTIVE: "SIDEBAR_ACTIVE",
        OPEN_ALERT: "OPEN_ALERT",
        CLOSE_ALERT: "CLOSE_ALERT",
        SHOW_EDIT_DATA: "SHOW_EDIT_DATA",
        OFFLINE_FALLBACK: "OFFLINE_FALLBACK",
        FULL_PAGE_LOADER: "FULL_PAGE_LOADER",
        GENERATE_NOTIFICATIONS: "GENERATE_NOTIFICATIONS",
        CLEAR_NOTIFICATIONS: "CLEAR_NOTIFICATIONS",
        DELETE_NOTIFICATIONS: "DELETE_NOTIFICATIONS",
        READ_NOTIFICATIONS: "READ_NOTIFICATIONS"
    },
    TAB: {
        UPDATE_TAB_VALUE: "UPDATE_TAB_VALUE",
        UPDATE_SUBTAB_VALUE: "UPDATE_SUBTAB_VALUE",
    },
    APPOINTMENTS: {
        UPDATE_SELECTED_LOCATIONS: 'UPDATE_SELECTED_LOCATIONS',
        UPDATE_SELECTED_DOCTORS: 'UPDATE_SELECTED_DOCTORS',
    },
    TASKS:{
        TASK_DETAILS :'TASK_DETAILS'
    }
};
